type Rates = {
  [key: string]: string;
};

export function convertCurrency(
  amount: number,
  from = "USD",
  to = "USD",
  rates: Rates
): number {
  const fromRate = parseFloat(rates[from]);
  const toRate = parseFloat(rates[to]);
  if (isNaN(fromRate) || isNaN(toRate)) {
    throw new Error("Invalid currency rate");
  }
  const amountInUSD = amount * fromRate;
  return amountInUSD / toRate;
}
